export default "__VITE_ASSET__CW_bAbkz__"